module.exports = __webpack_public_path__ + "img/arrow-left-eoi-request.1c5a0240.svg";